import { c as _c } from "react/compiler-runtime";
import type * as React from "react";
import { cn } from "../utils/cn";
import { Facebook, InstagramIcon, KununuIcon, Linkedin, PinterestIcon, SoundcloudIcon, SpotifyIcon, TikTokIcon, TwitterIcon, Xing, YouTubeIcon } from "./icons/social";
import { buttonVariants } from "./ui/button";
export type SocialPlatform = "facebook" | "twitter" | "youtube" | "xing" | "linkedin" | "tiktok" | "instagram" | "kununu" | "pinterest" | "soundcloud" | "spotify";
type SocialIcon = Record<SocialPlatform, React.ReactNode>;
const Icon = t0 => {
  const $ = _c(111);
  const {
    social,
    invert,
    custom
  } = t0;
  let t1;
  if ($[0] !== custom) {
    t1 = cn("text-[#4267B2]", custom);
    $[0] = custom;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== t1) {
    t2 = <Facebook className={t1} />;
    $[2] = t1;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== custom) {
    t3 = cn("text-black", custom);
    $[4] = custom;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] !== t3) {
    t4 = <TwitterIcon className={t3} />;
    $[6] = t3;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  let t5;
  if ($[8] !== custom) {
    t5 = cn("text-[#0077b5]", custom);
    $[8] = custom;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  let t6;
  if ($[10] !== t5) {
    t6 = <Linkedin className={t5} />;
    $[10] = t5;
    $[11] = t6;
  } else {
    t6 = $[11];
  }
  let t7;
  if ($[12] !== custom) {
    t7 = cn("text-[#126567]", custom);
    $[12] = custom;
    $[13] = t7;
  } else {
    t7 = $[13];
  }
  let t8;
  if ($[14] !== t7) {
    t8 = <Xing className={t7} />;
    $[14] = t7;
    $[15] = t8;
  } else {
    t8 = $[15];
  }
  let t9;
  if ($[16] !== custom) {
    t9 = cn("text-[#FF0000]", custom);
    $[16] = custom;
    $[17] = t9;
  } else {
    t9 = $[17];
  }
  let t10;
  if ($[18] !== t9) {
    t10 = <YouTubeIcon className={t9} />;
    $[18] = t9;
    $[19] = t10;
  } else {
    t10 = $[19];
  }
  let t11;
  if ($[20] !== custom) {
    t11 = cn("text-[#d62976]", custom);
    $[20] = custom;
    $[21] = t11;
  } else {
    t11 = $[21];
  }
  let t12;
  if ($[22] !== t11) {
    t12 = <InstagramIcon className={t11} />;
    $[22] = t11;
    $[23] = t12;
  } else {
    t12 = $[23];
  }
  let t13;
  if ($[24] !== custom) {
    t13 = cn("text-[text-black]", custom);
    $[24] = custom;
    $[25] = t13;
  } else {
    t13 = $[25];
  }
  let t14;
  if ($[26] !== t13) {
    t14 = <TikTokIcon className={t13} />;
    $[26] = t13;
    $[27] = t14;
  } else {
    t14 = $[27];
  }
  let t15;
  if ($[28] !== custom) {
    t15 = cn("text-[#99C613]", custom);
    $[28] = custom;
    $[29] = t15;
  } else {
    t15 = $[29];
  }
  let t16;
  if ($[30] !== t15) {
    t16 = <KununuIcon className={t15} />;
    $[30] = t15;
    $[31] = t16;
  } else {
    t16 = $[31];
  }
  let t17;
  if ($[32] !== custom) {
    t17 = cn("text-[#BD081C]", custom);
    $[32] = custom;
    $[33] = t17;
  } else {
    t17 = $[33];
  }
  let t18;
  if ($[34] !== t17) {
    t18 = <PinterestIcon className={t17} />;
    $[34] = t17;
    $[35] = t18;
  } else {
    t18 = $[35];
  }
  let t19;
  if ($[36] !== custom) {
    t19 = cn("text-[#FF5500]", custom);
    $[36] = custom;
    $[37] = t19;
  } else {
    t19 = $[37];
  }
  let t20;
  if ($[38] !== t19) {
    t20 = <SoundcloudIcon className={t19} />;
    $[38] = t19;
    $[39] = t20;
  } else {
    t20 = $[39];
  }
  let t21;
  if ($[40] !== custom) {
    t21 = cn("text-[#1DB954]", custom);
    $[40] = custom;
    $[41] = t21;
  } else {
    t21 = $[41];
  }
  let t22;
  if ($[42] !== t21) {
    t22 = <SpotifyIcon className={t21} />;
    $[42] = t21;
    $[43] = t22;
  } else {
    t22 = $[43];
  }
  let t23;
  if ($[44] !== t10 || $[45] !== t12 || $[46] !== t14 || $[47] !== t16 || $[48] !== t18 || $[49] !== t2 || $[50] !== t20 || $[51] !== t22 || $[52] !== t4 || $[53] !== t6 || $[54] !== t8) {
    t23 = {
      facebook: t2,
      twitter: t4,
      linkedin: t6,
      xing: t8,
      youtube: t10,
      instagram: t12,
      tiktok: t14,
      kununu: t16,
      pinterest: t18,
      soundcloud: t20,
      spotify: t22
    };
    $[44] = t10;
    $[45] = t12;
    $[46] = t14;
    $[47] = t16;
    $[48] = t18;
    $[49] = t2;
    $[50] = t20;
    $[51] = t22;
    $[52] = t4;
    $[53] = t6;
    $[54] = t8;
    $[55] = t23;
  } else {
    t23 = $[55];
  }
  let t24;
  if ($[56] !== custom) {
    t24 = cn("text-white", custom);
    $[56] = custom;
    $[57] = t24;
  } else {
    t24 = $[57];
  }
  let t25;
  if ($[58] !== t24) {
    t25 = <Facebook className={t24} />;
    $[58] = t24;
    $[59] = t25;
  } else {
    t25 = $[59];
  }
  let t26;
  if ($[60] !== custom) {
    t26 = cn("text-white", custom);
    $[60] = custom;
    $[61] = t26;
  } else {
    t26 = $[61];
  }
  let t27;
  if ($[62] !== t26) {
    t27 = <TwitterIcon className={t26} />;
    $[62] = t26;
    $[63] = t27;
  } else {
    t27 = $[63];
  }
  let t28;
  if ($[64] !== custom) {
    t28 = cn("text-white", custom);
    $[64] = custom;
    $[65] = t28;
  } else {
    t28 = $[65];
  }
  let t29;
  if ($[66] !== t28) {
    t29 = <Linkedin className={t28} />;
    $[66] = t28;
    $[67] = t29;
  } else {
    t29 = $[67];
  }
  let t30;
  if ($[68] !== custom) {
    t30 = cn("text-white", custom);
    $[68] = custom;
    $[69] = t30;
  } else {
    t30 = $[69];
  }
  let t31;
  if ($[70] !== t30) {
    t31 = <Xing className={t30} />;
    $[70] = t30;
    $[71] = t31;
  } else {
    t31 = $[71];
  }
  let t32;
  if ($[72] !== custom) {
    t32 = cn("text-white", custom);
    $[72] = custom;
    $[73] = t32;
  } else {
    t32 = $[73];
  }
  let t33;
  if ($[74] !== t32) {
    t33 = <YouTubeIcon className={t32} />;
    $[74] = t32;
    $[75] = t33;
  } else {
    t33 = $[75];
  }
  let t34;
  if ($[76] !== custom) {
    t34 = cn("text-white", custom);
    $[76] = custom;
    $[77] = t34;
  } else {
    t34 = $[77];
  }
  let t35;
  if ($[78] !== t34) {
    t35 = <InstagramIcon className={t34} />;
    $[78] = t34;
    $[79] = t35;
  } else {
    t35 = $[79];
  }
  let t36;
  if ($[80] !== custom) {
    t36 = cn("text-white", custom);
    $[80] = custom;
    $[81] = t36;
  } else {
    t36 = $[81];
  }
  let t37;
  if ($[82] !== t36) {
    t37 = <TikTokIcon className={t36} />;
    $[82] = t36;
    $[83] = t37;
  } else {
    t37 = $[83];
  }
  let t38;
  if ($[84] === Symbol.for("react.memo_cache_sentinel")) {
    t38 = <KununuIcon className={cn("text-white")} />;
    $[84] = t38;
  } else {
    t38 = $[84];
  }
  let t39;
  if ($[85] !== custom) {
    t39 = cn("text-white", custom);
    $[85] = custom;
    $[86] = t39;
  } else {
    t39 = $[86];
  }
  let t40;
  if ($[87] !== t39) {
    t40 = <PinterestIcon className={t39} />;
    $[87] = t39;
    $[88] = t40;
  } else {
    t40 = $[88];
  }
  let t41;
  if ($[89] !== custom) {
    t41 = cn("text-white", custom);
    $[89] = custom;
    $[90] = t41;
  } else {
    t41 = $[90];
  }
  let t42;
  if ($[91] !== t41) {
    t42 = <SoundcloudIcon className={t41} />;
    $[91] = t41;
    $[92] = t42;
  } else {
    t42 = $[92];
  }
  let t43;
  if ($[93] !== custom) {
    t43 = cn("text-white", custom);
    $[93] = custom;
    $[94] = t43;
  } else {
    t43 = $[94];
  }
  let t44;
  if ($[95] !== t43) {
    t44 = <SpotifyIcon className={t43} />;
    $[95] = t43;
    $[96] = t44;
  } else {
    t44 = $[96];
  }
  let t45;
  if ($[97] !== t25 || $[98] !== t27 || $[99] !== t29 || $[100] !== t31 || $[101] !== t33 || $[102] !== t35 || $[103] !== t37 || $[104] !== t40 || $[105] !== t42 || $[106] !== t44) {
    t45 = {
      facebook: t25,
      twitter: t27,
      linkedin: t29,
      xing: t31,
      youtube: t33,
      instagram: t35,
      tiktok: t37,
      kununu: t38,
      pinterest: t40,
      soundcloud: t42,
      spotify: t44
    };
    $[97] = t25;
    $[98] = t27;
    $[99] = t29;
    $[100] = t31;
    $[101] = t33;
    $[102] = t35;
    $[103] = t37;
    $[104] = t40;
    $[105] = t42;
    $[106] = t44;
    $[107] = t45;
  } else {
    t45 = $[107];
  }
  let t46;
  if ($[108] !== t23 || $[109] !== t45) {
    t46 = {
      default: t23,
      invert: t45
    };
    $[108] = t23;
    $[109] = t45;
    $[110] = t46;
  } else {
    t46 = $[110];
  }
  const icons = t46;
  if (invert) {
    return icons.invert[social];
  }
  return icons.default[social];
};
export function SocialLink(t0) {
  const $ = _c(27);
  let children;
  let className;
  let classNameIcon;
  let href;
  let invert;
  let props;
  let ref;
  let social;
  let t1;
  if ($[0] !== t0) {
    ({
      children,
      className,
      social,
      classNameIcon,
      target: t1,
      href,
      invert,
      ref,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = children;
    $[2] = className;
    $[3] = classNameIcon;
    $[4] = href;
    $[5] = invert;
    $[6] = props;
    $[7] = ref;
    $[8] = social;
    $[9] = t1;
  } else {
    children = $[1];
    className = $[2];
    classNameIcon = $[3];
    href = $[4];
    invert = $[5];
    props = $[6];
    ref = $[7];
    social = $[8];
    t1 = $[9];
  }
  const target = t1 === undefined ? "_blank" : t1;
  const t2 = `Link to ${social ? social : "SocialMedia"} page`;
  let t3;
  if ($[10] !== className || $[11] !== invert || $[12] !== social) {
    t3 = cn(buttonVariants({
      variant: "social",
      size: "social",
      backgroundColor: invert ? social : "default"
    }), className);
    $[10] = className;
    $[11] = invert;
    $[12] = social;
    $[13] = t3;
  } else {
    t3 = $[13];
  }
  let t4;
  if ($[14] !== classNameIcon || $[15] !== invert || $[16] !== social) {
    t4 = social && <Icon custom={cn("size-6", classNameIcon)} invert={invert} social={social} />;
    $[14] = classNameIcon;
    $[15] = invert;
    $[16] = social;
    $[17] = t4;
  } else {
    t4 = $[17];
  }
  let t5;
  if ($[18] !== children || $[19] !== href || $[20] !== props || $[21] !== ref || $[22] !== t2 || $[23] !== t3 || $[24] !== t4 || $[25] !== target) {
    t5 = <a aria-label={t2} className={t3} href={href} ref={ref} rel="noreferrer" target={target} {...props}>{t4}{children}</a>;
    $[18] = children;
    $[19] = href;
    $[20] = props;
    $[21] = ref;
    $[22] = t2;
    $[23] = t3;
    $[24] = t4;
    $[25] = target;
    $[26] = t5;
  } else {
    t5 = $[26];
  }
  return t5;
}